import React from 'react'
import "../Components/Loader.scss"
import { ProgressSpinner } from 'primereact/progressspinner';


const Loader = ({isExporting}) => {
  return (
    <>
      {isExporting && (
          <div className="export-loader-overlay">
            <ProgressSpinner />
          </div>
        )}
    </>
  )
}

export default Loader